
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aYVVm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $133256a5190381b7$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $b31tm = parcelRequire("b31tm");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $cR2Ov = parcelRequire("cR2Ov");

var $32ng3 = parcelRequire("32ng3");

var $iSeHD = parcelRequire("iSeHD");

var $9KOR3 = parcelRequire("9KOR3");
const $133256a5190381b7$var$JiraServiceManagementLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.LogoV3), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.LogoV2), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand"
    });
};
const $133256a5190381b7$var$JiraServiceManagementSoftwareNavV2 = ({ productNavCtaCTAClickFunction: productNavCtaCTAClickFunction, isUseOpenCrossFlow: isUseOpenCrossFlow = false })=>{
    var _links_find, _links_find1;
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    const intl = (0, $8e22h.default)();
    const featuresHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/features");
    const pricingHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/pricing");
    const itSupportHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/itsm-software");
    const itOperationsHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/it-operations");
    const enterpriseServiceManagementHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/features/enterprise-service-management");
    const customerServiceHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/customer-service-software");
    const hrHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/hr");
    const smallTeamsHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/help-desk-software-small-business-software");
    const premiumHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/premium");
    const enterpriseHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/enterprise");
    const technologyTelecomHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/technology-telecommunications");
    const financialServicesHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/financial-services");
    const retailHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/retail-ecommerce");
    const manufacturingHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/manufacturing");
    const itsmHref = (0, $kooLp.useLocalizedHref)("/itsm");
    const productGuideHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/product-guide");
    const resourcesHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/resources");
    const solutionsDropdownStyles = (0, $gljCV.useMemo)(()=>{
        return {
            width: "fit-content !important",
            margin: 0,
            transform: "translateX(-40%)"
        };
    }, []);
    const templatesUrl = (0, $kooLp.useLocalizedHref)("/software/jira/templates/service-management");
    const { fireUIEvent: fireUIEvent } = (0, $b31tm.useFireEvent)();
    const viewedUIEvent = (0, $gljCV.useRef)(false);
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    (0, $gljCV.useEffect)(()=>{
        if (!viewedUIEvent.current && analyticsClient) {
            viewedUIEvent.current = true;
            fireUIEvent({
                action: "viewed",
                actionSubject: "jiraServiceManagementSoftwareNavV2"
            });
        }
    }, [
        analyticsClient,
        fireUIEvent
    ]);
    const links = (0, $gljCV.useMemo)(()=>[
            {
                globalLinksKey: "features",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.features",
                    defaultMessage: "Features"
                }),
                hasSubnav: false,
                productKey: "jira-servicedesk.ondemand",
                href: featuresHref
            },
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "jira-servicedesk.ondemand",
                href: pricingHref
            },
            {
                globalLinksKey: "solutions",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.solutions",
                    defaultMessage: "Solutions"
                }),
                hasSubnav: true,
                dropdownType: "solutions",
                productKey: "jira-servicedesk.ondemand",
                containerPosition: "relative",
                containerStyles: solutionsDropdownStyles,
                content: /*#__PURE__*/ (0, $dypTs.jsx)((0, $cR2Ov.DropdownContent), {
                    contentSections: [
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.solutions.useCases.header",
                                defaultMessage: "By use case"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.itSupport",
                                        defaultMessage: "IT Support"
                                    }),
                                    href: itSupportHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.itOperations",
                                        defaultMessage: "IT Operations"
                                    }),
                                    href: itOperationsHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.businessTeams",
                                        defaultMessage: "Business Teams"
                                    }),
                                    href: enterpriseServiceManagementHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.customerService",
                                        defaultMessage: "Customer Service"
                                    }),
                                    href: customerServiceHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.humanResources",
                                        defaultMessage: "Human Resources"
                                    }),
                                    href: hrHref
                                }
                            ]
                        },
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.solutions.capability.header",
                                defaultMessage: "By capability"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.capability.smallTeams",
                                        defaultMessage: "Small Teams"
                                    }),
                                    href: smallTeamsHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.capability.premium",
                                        defaultMessage: "Premium"
                                    }),
                                    href: premiumHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.capability.enterprise",
                                        defaultMessage: "Enterprise"
                                    }),
                                    href: enterpriseHref
                                }
                            ]
                        },
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.solutions.industry.customerService",
                                defaultMessage: "By industry"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.industry.technologyTelecom",
                                        defaultMessage: "Technology & Telecom"
                                    }),
                                    href: technologyTelecomHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.industry.financialServices",
                                        defaultMessage: "Financial Services"
                                    }),
                                    href: financialServicesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.industry.retail",
                                        defaultMessage: "Retail"
                                    }),
                                    href: retailHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.manufacturing",
                                        defaultMessage: "Manufacturing"
                                    }),
                                    href: manufacturingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "resources",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.resources",
                    defaultMessage: "Resources"
                }),
                hasSubnav: true,
                dropdownType: "resources",
                productKey: "jira-servicedesk.ondemand",
                containerPosition: "relative",
                content: /*#__PURE__*/ (0, $dypTs.jsx)((0, $cR2Ov.DropdownContent), {
                    contentSections: [
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.resources.type.header",
                                defaultMessage: "By type"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.itsm",
                                        defaultMessage: "ITSM"
                                    }),
                                    href: itsmHref
                                },
                                {
                                    text: gwp7518NavIconUpdates ? intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.productGuide-gwp-7518",
                                        defaultMessage: "Guide"
                                    }) : intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.productGuide",
                                        defaultMessage: "Product Guide"
                                    }),
                                    href: productGuideHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.additionalResources",
                                        defaultMessage: "Additional Resources"
                                    }),
                                    href: resourcesHref
                                }
                            ]
                        }
                    ]
                })
            }
        ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        customerServiceHref,
        solutionsDropdownStyles,
        enterpriseHref,
        enterpriseServiceManagementHref,
        featuresHref,
        financialServicesHref,
        hrHref,
        intl,
        itOperationsHref,
        itSupportHref,
        itsmHref,
        manufacturingHref,
        premiumHref,
        pricingHref,
        productGuideHref,
        resourcesHref,
        retailHref,
        smallTeamsHref,
        technologyTelecomHref,
        templatesUrl
    ]);
    const signupLink = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/free");
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_SERVICE_DESK,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const productNavOnClick = (0, $gljCV.useMemo)(()=>productNavCtaCTAClickFunction && isUseOpenCrossFlow ? productNavCtaCTAClickFunction : openCrossFlow, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        openCrossFlow,
        productNavCtaCTAClickFunction
    ]);
    const globalNavItemKeys = (0, $gljCV.useMemo)(()=>{
        return links.map((link)=>link.globalLinksKey);
    }, [
        links
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $9KOR3.GlobalNavProvider), {
        globalNavItemKeys: globalNavItemKeys,
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $l2QYX.ProductPageSubNav), {
            productLogo: /*#__PURE__*/ (0, $dypTs.jsx)($133256a5190381b7$var$JiraServiceManagementLogo, {}),
            mobileLogo: /*#__PURE__*/ (0, $dypTs.jsx)($133256a5190381b7$var$JiraServiceManagementLogo, {}),
            productLogoUrl: (0, $kooLp.useLocalizedHref)("/software/jira/service-management"),
            productLogoAriaLabel: "Jira Service Management",
            productPageNavLinks: links,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-jira-service-management",
                    mobileLinksProps: links
                }
            ],
            mobileCtaText: intl.formatMessage({
                id: "productNavBar.get-it-free-button",
                defaultMessage: "Get it free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            navigationTrynowCtaText: intl.formatMessage({
                id: "productNavBar.get-it-free-button",
                defaultMessage: "Get it free"
            }),
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            additionalMenuPageObjectsArray: [
                {
                    menuPageKey: "solutions",
                    menuPageObjects: (_links_find = links.find((link)=>link.globalLinksKey === "solutions")) === null || _links_find === void 0 ? void 0 : _links_find.content
                },
                {
                    menuPageKey: "resources",
                    menuPageObjects: (_links_find1 = links.find((link)=>link.globalLinksKey === "resources")) === null || _links_find1 === void 0 ? void 0 : _links_find1.content
                }
            ]
        })
    });
};
var $133256a5190381b7$export$2e2bcd8739ae039 = $133256a5190381b7$var$JiraServiceManagementSoftwareNavV2;

});


//# sourceMappingURL=jira-service-management-pricing-page.29bb27aa.js.map
